import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Section } from '../ui/Section';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: "Is $6.36 really the full price? What's the catch?",
    a: 'There is no catch. You get the complete guide plus all 3 bonuses for $6.36. It is a one-time payment. No subscriptions, no hidden fees. We keep the price this low because we want to help as many normal people as possible buy a home this year.'
  }, {
    q: 'I know nothing about real estate. Will this make sense to me?',
    a: 'Yes! We wrote this specifically for people who have never bought a house before. We removed all the confusing industry words. If you know how to use a phone to look at houses online, you can easily follow this guide.'
  }, {
    q: 'Do I need a ton of cash saved up or perfect credit?',
    a: "No. You don't need to be rich. We show you a simple trick where you buy the house cheap first, and then easily switch it into a normal, low-down-payment monthly mortgage later."
  }, {
    q: 'I work full time. How much time does this take?',
    a: 'You only need about 30 minutes a day to look for deals online. You can easily do it in the evenings or on weekends from your couch.'
  }, {
    q: 'Is buying at auction risky?',
    a: "Not if you know what to look for. We give you a simple checklist to make sure the house doesn't have any hidden debts or major problems before you ever try to buy it."
  }, {
    q: 'Does this actually work right now?',
    a: "Yes. Right now, normal houses are selling for crazy high prices because everyone is fighting over them. But auction homes are still selling for way less because most normal buyers don't know how to find them."
  }, {
    q: 'Can I do this where I live?',
    a: 'Yes. You can find these deals anywhere in the country. The rules change a little bit depending on your state, but we explain exactly how to figure that out.'
  }, {
    q: 'What if someone is currently living in the house?',
    a: 'We show you a very simple, friendly way to offer them a little bit of moving money so they leave happily and quickly, without any drama.'
  }, {
    q: 'How long does it take to get the guide after I pay?',
    a: 'You get it instantly. As soon as you check out, you can download the PDF guide and all the bonuses right to your phone or computer.'
  }, {
    q: "What if I read it and don't like it?",
    a: "You have a full 7 days to decide. If you read it and don't think it was helpful, just email us and we will give you your $6.36 back immediately. No questions asked."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section theme="black" className="border-b border-slate-100" data-id="element-110">
      <div className="max-w-3xl mx-auto" data-id="element-111">
        <h2 className="text-3xl md:text-4xl font-display font-bold mb-14 text-center text-slate-900" data-id="element-112">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4" data-id="element-113">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <div key={idx} className={`bg-white rounded-2xl border border-slate-200 shadow-sm transition-all duration-300 ${isOpen ? 'border-orange-500 shadow-md ring-1 ring-orange-500' : 'hover:border-orange-200'}`} data-id="element-114">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full flex items-center justify-between p-6 md:p-8 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-orange-500 rounded-2xl" aria-expanded={isOpen} data-id="element-115">
                  <span className="text-lg md:text-xl font-display font-bold text-slate-900 pr-8" data-id="element-116">
                    {faq.q}
                  </span>
                  <div className={`shrink-0 p-1.5 rounded-full transition-colors ${isOpen ? 'bg-orange-100 text-orange-600' : 'bg-slate-50 text-slate-400'}`} data-id="element-117">
                    {isOpen ? <Minus className="w-5 h-5" data-id="element-118" /> : <Plus className="w-5 h-5" data-id="element-119" />}
                  </div>
                </button>

                <AnimatePresence data-id="element-120">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-121">
                      <div className="p-6 md:p-8 pt-0 text-slate-600 text-lg leading-relaxed border-t border-slate-100 mx-6 md:mx-8 px-0 mt-2" data-id="element-122">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </Section>;
}